import React from 'react';
import { Body3 } from '../../../../../atomic/text/Text';
import { headerList } from './headerList';

export const ExecutionsHeader = () => {
  return (
    <thead>
      <tr>
        {headerList.map(({ label }) => (
          <th key={label}>
            <Body3 fontWeight={700}>{label}</Body3>
          </th>
        ))}
      </tr>
    </thead>
  );
};
